/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { next } from '@ember/runloop';

export default class AssessmentRoute extends Route {
  queryParams = {
    asOnDate: {
      refreshModel: true,
      as: 'asOnDate',
    },
  };

  // Services
  @service
  session;

  @service
  store;

  model(params) {
    let store = this.store;
    let pageModel = this.modelFor('group.page');
    let asAtTime = isEmpty(params.asOnDate)
      ? undefined
      : moment(params.asOnDate).endOf('day').unix();
    let today = {
      start: moment().startOf('day').unix(),
      end: moment().endOf('day').unix(),
    };
    return hash({
      grades: store.query('assessments/grade', {
        assessmentId: params.assessment_id,
        groupId: pageModel.group.id,
        latest: false,
        asAtTime,
      }),
      modules: store.query('assessments/module', {
        assessmentId: params.assessment_id,
        include: 'gradeSchedules',
      }),
      assessment: store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      group: pageModel.group,
      page: pageModel.page,
      posts: store.query('posts/post', {
        groupId: pageModel.group.id,
        assessmentId: params.assessment_id,
        startTime: today.start,
        endTime: today.end,
      }),
    });
  }

  setupController() {
    super.setupController(...arguments);
    this.controller.setProperties({
      autosaveNumericGrades: this.controller.get(
        'personOptions.autosaveNumericGrades',
      ),
      newAsOnDate: this.controller.asOnDate,
      newFromDate: this.controller.fromDate,
      selectedLearners: [],
      selectedLearnerObjects: [],
      bulkGrades: [],
      filteredModules: this.controller.get('assessment.sortedModules').slice(),
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
